<template>
  <div class="card card-custom">
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">
          {{ $t("emailSettings.completeProfile") }}
        </h3>

        <span class="text-muted font-weight-bold font-size-sm mt-1">
          {{ $t("emailSettings.completeProfileDesc") }}
        </span>
      </div>
      <div class="card-toolbar">
        <v-row no-gutters>
          <v-col>
            <v-btn
                :class="
                user.auth_validate === status.ACCEPT
                  ? 'btn-update'
                  : 'submit-btn'
              "
                :loading="loading"
                class="px-5"
                @click="sendData"
            >
              <v-icon v-if="user.auth_validate === status.ACCEPT" class="pl-2">update
              </v-icon>
              <span v-else class="fa fa-bookmark icon-md ml-1"></span>
              {{
                user.auth_validate === status.ACCEPT
                    ? $t("emailSettings.update")
                    : $t("emailSettings.save")
              }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <edit-profile v-model="editInfo" :errorsMessage="errorsMessage"/>
  </div>
</template>

<script>
import EditProfile from "./EditProfile.vue";
import i18n from "@/i18n";

export default {
  name: "EmailSettings",
  i18n,
  components: {
    EditProfile,
  },
  data() {
    return {
      editInfo: {
        type: null,
        name: null,
        phone: null,
        telephone: null,
        username: null,
        fatherName: null,
        nid: null,
        birthday: "2005-03-21",
        born_city: null,
        postalCode: null,
        email: null,
        introduction: null,
        nid_img: null,
        picWithNationalCode: null,
        // plaque: null,
        yourCatch: null,
        address: null,
        registrationNumber: null,
        economicCode: null,
        organizationIdentity: null,
        activity: null,
        registrationAd: null,
        lastPublishedAd: null,
        statute: null,
        agent_letterpic: null,
        companyType: null,
      },
      errorsMessage: {},
      rules: {},
      loading: false,
      items: [
        {
          name: this.$t("emailSettings.companyTypes.governmental"),
          valueName: "governmental",
        },
        {
          name: this.$t("emailSettings.companyTypes.private"),
          valueName: "private",
        },
        {
          name: this.$t("emailSettings.companyTypes.commonStock"),
          valueName: "common_stock",
        },
        {
          name: this.$t("emailSettings.companyTypes.specialStock"),
          valueName: "special_stock",
        },
      ],
    };
  },
  computed: {
    status() {
      return {
        ACCEPT: "accept",
        Reject: "reject",
        PENDING: "pending",
      };
    },
  },
  methods: {
    changeCompanyType(item) {
      this.editInfo.companyType = item.valueName;
    },
    sendData() {
      const formData = new FormData()

      this.realData(formData)

      if (this.editInfo.type === 'legal') {
        this.legalData(formData);
      }

      this.submitData(formData);
    },
    legalData(formData) {
      this.loading = true;
      const vm = this;

      formData.append("type", "legal");
      formData.append("company_name", vm.editInfo.company_name ?? null);
      formData.append("registration_number", this.english(vm.editInfo?.registrationNumber));
      formData.append("economic_code", this.english(vm.editInfo?.economicCode));
      formData.append("organization_identity", this.english(vm.editInfo?.organizationIdentity));
      formData.append("activity", vm.editInfo?.activity);
      formData.append("registration_ad", vm.editInfo?.registrationAd);
      formData.append("telephone", vm.editInfo?.telephone);
      formData.append("last_published_ad", vm.editInfo?.lastPublishedAd);
      formData.append("statute", vm.editInfo?.statute);
      formData.append("agent_letterpic", vm.editInfo?.agent_letterpic);
      formData.append("company_type", vm.editInfo?.companyType||'');
      formData.append("phone", this.user?.phone);
      formData.append("email", this.user?.email);
      formData.append("agree", 1);
      formData.append("postalCode", vm.editInfo?.postalCode??'');
      formData.append("address", vm.editInfo?.address??'');



      return formData;
    },
    realData(formData) {
      this.loading = true;
      const vm = this;

      formData.append("type", "regular");
      formData.append("name", vm.editInfo?.name);
      formData.append("father_name", vm.editInfo?.fatherName);
      formData.append("postalCode", vm.editInfo?.postalCode);
      formData.append("birthday", vm.editInfo?.birthday);
      formData.append("born_city", vm.editInfo?.born_city);
      formData.append("nid_img", vm.editInfo?.nid_img);
      formData.append("selfieimg", vm.editInfo?.picWithNationalCode);
      formData.append("address", vm.editInfo?.address);
      formData.append("bill", vm.editInfo?.yourCatch);
      formData.append("telephone", vm.editInfo?.telephone);
      // formData.append("plaque", vm.editInfo.plaque);
      formData.append("introduction", vm.editInfo?.introduction);
      formData.append("phone", this.user?.phone);
      formData.append("email", this.user?.email);
      formData.append("agree", 1);

      return formData;
    },
    submitData(formData) {
      this.requestApiPost("confirmprofile", formData, this.configurationFile())
          .then(({data}) => {
            this.loading = false;
            this.$toast.success(this.$t("emailSettings.successMessage"));
            this.authority();
          })
          .catch(({response}) => {
            this.loading = false;
            if (response && response.status === 422) {
              this.errorsMessage = response.data.errors;
              if (response.data.message) {
                this.$toast.error(response.data.message);
              }
            } else {
              this.$toast.error("An unexpected error occurred.");
            }
          });
    },
    configurationFile() {
      return {
        headers: {"Content-Type": "multipart/form-data"},
        onUploadProgress: function (progressEvent) {
          this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$forceUpdate();
        }.bind(this),
      };
    },
  },
};
</script>
